'use client';

import React, { FC, memo, useEffect } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { Reference } from 'types/reference';
import { useAccount } from 'frontastic/hooks';
import Image, { ImageProps } from 'frontastic/lib/image';

export interface Props {
  logo: ImageProps;
  logoLink: Reference;
  logoLinkDataAnalytics?: string;
  imageClassName?: string;
  onClick?: () => void;
}

const HeaderLogo: FC<Props> = ({ logoLink, logo, imageClassName, logoLinkDataAnalytics, onClick }) => {
  const { verifyLoggedIn } = useAccount();
  useEffect(() => {
    verifyLoggedIn();
  }, []);

  return (
    <div className="relative h-40 md:mt-0" onClick={onClick}>
      <Link className={imageClassName} link={logoLink} padi-analytics={logoLinkDataAnalytics}>
        <Image media={logo?.media} fill style={{ objectFit: 'contain' }} alt={logo?.title} priority />
      </Link>
    </div>
  );
};

export default memo(HeaderLogo);
